<template>
  <b-modal
    id="historicoCertificado"
    ref="historicoCertificado"
    hide-footer
    :no-enforce-focus="true"
    title="Histórico de baixa do certificado"
    @hidden="fechar()"
  >
    <div>
      <div
        v-for="historico in historicos"
        :key="historico.id"
        class="history-row mb-3 d-inline-flex"
      >
        <!-- <div class=""> -->
        <font-awesome-icon
          :icon="faHistory"
          class="text-primary mr-50"
          style="font-size:1.3rem !important;margin-top: 3px;"
        />
        <!-- </div> -->
        <div>
          <strong>{{ historico.usuario }}</strong>
          &nbsp;{{ historico.descricao }}.
          <div
            class="detail mt-50"
            style="font-size: 12.5px;"
          ><b>{{ historico.dataCadastro }} </b></div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faHistory,
} from '@fortawesome/free-solid-svg-icons'
import { formatDate } from '@core/utils/filter'
import api from '@/app-modulo/comuns/certificado/shared/services/api'

export default {
  name: 'HistoricoCertificado',
  components: {
    FontAwesomeIcon,
  },
  props: {
    certificadoId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      formatDate,
      faHistory,
      historicos: null,
    }
  },
  methods: {
    show(id) {
      if (id > 0) {
        api.getHistoricos(id)
          .then(payload => {
            this.historicos = payload.data
            this.$refs.historicoCertificado.show()
          })
          .catch(() => {
            this.$erro('Não foi possível buscar históricos')
          })
      }
    },
    fechar() {
      this.$emit('hidden')
    },
  },
}
</script>
